export default __webpack_public_path__ + "static/brand-17-c534e1b5e3c25542f01dcd4df28c0f22.png";